module.exports = "images/LOADER_infini.28df1a9b.gif";